/** Metric parsing helpers — ported from prototype screens-edit.jsx */

export const FOCUS_ICON = {
  techSales: '✂️',
  retailSales: '🛍️',
  customerCount: '👥',
  customerUnitPrice: '💰',
  nominationRate: '⭐',
  nomination: '⭐',
  newReturnRate: '🔁',
  newReturn: '🔁',
  existingReturnRate: '♻️',
  productPurchaseRate: '🧴',
  churnRate: '📉',
  karteCount: '🗂',
  visitFrequency: '📅',
  dailyVisitor: '🧑',
  unitPrice: '💰',
  totalSales: '💴',
};

export function parseMetric(v) {
  const s = String(v).replace(/[,，]/g, '');
  const num = parseFloat(s.replace(/[^0-9.]/g, '')) || 0;
  let unit = 'num';
  if (s.includes('¥')) unit = 'currency';
  else if (s.includes('%')) unit = 'percent';
  else if (s.includes('名')) unit = 'count';
  else if (s.includes('件')) unit = 'pieces';
  else if (s.includes('日')) unit = 'days';
  return { num, unit, decimal: s.includes('.') };
}

export function fmtMetric(unit, v) {
  if (v == null || Number.isNaN(v)) return '—';
  if (unit === 'currency') return `¥${Math.round(v).toLocaleString()}`;
  if (unit === 'percent') return `${Math.round(v * 10) / 10}%`;
  if (unit === 'count') return `${Math.round(v * 10) / 10}名`;
  if (unit === 'pieces') return `${Math.round(v)}件`;
  if (unit === 'days') return `${Math.round(v)}日`;
  return String(Math.round(v));
}

export function stepMetric(m) {
  if (m.unit === 'currency') {
    if (m.num >= 100000) return 10000;
    if (m.num >= 10000) return 1000;
    return 100;
  }
  if (m.unit === 'count') return m.decimal ? 0.1 : 1;
  return 1;
}

export const PROPOSED_ACTIONS = {
  newReturn: [
    { id: 1, name: '次回来店の目安を会計前に必ず伝える', cadence: '新規のお客様ごとに' },
    { id: 2, name: 'カルテに次回提案日と理由を1行メモする', cadence: '新規のお客様ごとに' },
    { id: 3, name: '1ヶ月後にDMかLINEで一言フォローする', cadence: '1日1名を目安に' },
  ],
  unitPrice: [
    { id: 1, name: '施術中にホームケアのおすすめを1点紹介', cadence: 'お会計ごとに' },
    { id: 2, name: '次回向けにメニュー追加の提案を1回行う', cadence: '新規のお客様ごとに' },
    { id: 3, name: '店販サンプルの感想を翌週ヒアリング', cadence: '1日1名を目安に' },
  ],
};

export const ALT_ACTIONS = {
  newReturn: [
    { id: 1, name: '施術後に「次のおすすめ来店時期」をカルテに残す', cadence: '新規のお客様ごとに' },
    { id: 2, name: '施術中に1つだけホームケアの相談を聞く', cadence: '新規のお客様ごとに' },
    { id: 3, name: '2週間後にLINEでヘアケアの様子をうかがう', cadence: '1日1名を目安に' },
  ],
  unitPrice: [
    { id: 1, name: 'カウンセリング時に悩みに対応したメニューを1つ提案', cadence: '新規のお客様ごとに' },
    { id: 2, name: '施術仕上げにホームケア商品を1つ手に取って紹介', cadence: 'お会計ごとに' },
    { id: 3, name: '次回予約時にメンテナンスメニューの案内', cadence: '1日1名を目安に' },
  ],
};
